import Head from '@/components/layout/Head';

const PayPalGebuehren = () => {
  return (
    <>
      <Head
        title="PayPal Gebühren 2025 - Aktuelle Übersicht | paycal.org"
        description="Komplette Übersicht der PayPal Gebühren 2025. Informieren Sie sich über aktuelle Kosten für Verkäufer, Händler und private Nutzer."
        canonical="https://paycal.org/paypal-gebuehren"
      />
      <div className="container mx-auto px-4 py-8">
        <article className="prose max-w-none">
          <h1>PayPal Gebühren 2025 - Aktuelle Übersicht</h1>

          <h2>Standardgebühren für Verkäufer</h2>
          <p>
            Seit Januar 2025 gelten für PayPal-Transaktionen folgende 
            Standardgebühren für Verkäufer: 2,49% + 0,35 € für Inlandstransaktionen. 
            Diese Gebühren fallen bei jeder Transaktion für Waren oder 
            Dienstleistungen an.
          </p>

          <h2>Gebührenfreie Transaktionen</h2>
          <p>
            Zahlungen an Freunde und Familie innerhalb Deutschlands sind gebührenfrei, 
            sofern keine Währungsumrechnung erforderlich ist. Dies gilt jedoch nicht 
            für geschäftliche Transaktionen.
          </p>

          <h2>Händlerkonditionen</h2>
          <p>
            Für Händler mit höherem Transaktionsvolumen bietet PayPal gestaffelte 
            Gebührenmodelle an. Die Konditionen richten sich nach dem monatlichen 
            Verkaufsvolumen und beginnen bei 2,49% + 0,35 € für Umsätze bis 2.000 €.
          </p>

          {/* Additional sections about PayPal fees */}
        </article>
      </div>
    </>
  );
};

export default PayPalGebuehren;